import React from 'react';
// import 'bootstrap/dist/css/bootstrap.css';
import Spinner from 'react-bootstrap/Spinner';

export default function Loader() {
  return (
    <div className='loader_style'> 
      <Spinner animation="border" variant="primary" />
    </div>
  );
}
